import { colors as themeColors } from '../../utils/theme';
import { useState, useEffect } from 'react';
import { Box, Button, Checkbox, Typography, TextField, Grid, Paper, IconButton, Divider, Avatar, Tooltip} from '@mui/material';
import { Add, FilterList, Delete, Download, ExpandMore } from '@mui/icons-material';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const InquiryDetail = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({ inquiryNumber: '', inquiryDate: '', contactPerson: '', companyName: '', state: '', city: '' });
    const [resetFlag, setResetFlag] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(5);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [mode, setMode] = useState('search');
    const [filterVisible, setFilterVisible] = useState(false);

    useEffect(() => {
        fetchData();
        fetchTotalCount();
    }, [resetFlag, offset, limit, mode]);

    const fetchData = async () => {
        let apiUrl = `http://192.168.1.248:3103/api/inqdetails/search?mode=${mode}&offset=${offset}&limit=${limit}`;

        if (mode === 'search' && !resetFlag) {
            const query = new URLSearchParams(filters).toString();
            apiUrl += `&${query}`;
        }

        try {
            const response = await axios.get(apiUrl);
            console.log(response.data);
            if (Array.isArray(response.data)) {
                setData(offset === 0 ? response.data : [...data, ...response.data]);
            } else {
                // fallback: no data returned
                setData([]);
            }
        } catch (error) {
            if (error.response?.status === 304) {
                // No data found
                setData([]); // Clear existing data
                setTotalCount(0); // Optional: reset count to 0
            } else {
                console.error('Error fetching data:', error);
            }
        }
    };

    const fetchTotalCount = async () => {
        try {
            const response = await axios.get('http://192.168.1.248:3103/api/inqdetails/count');
            setTotalCount(response.data);
        } catch (error) {
            console.error('Error fetching total count:', error);
        }
    };

    const handleSearch = () => {
        setOffset(0);
        setMode('search');
        fetchData();
        fetchTotalCount();
    };

    const handleReset = () => {
        setResetFlag(1);
        setFilters({ inquiryNumber: '', inquiryDate: '', contactPerson: '', companyName: '', state: '', city: '' });
        setOffset(0);
        setSelectedRows([]);
        setSelectAll(false);
    };

    const handleExport = async () => {
        try {
            const response = await axios.get(`http://192.168.1.248:3103/api/inqdetails/search?mode=export`, { responseType: 'blob' });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'QoutationExport.xlsx');
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Error exporting:', error);
        }
    };

    const handleDelete = async () => {
        try {
            await axios.post('http://192.168.1.248:3103/api/inquiries/delete', {
                objAryId: selectedRows
            });
            handleReset();
        } catch (error) {
            console.error('Error deleting rows:', error);
        }
    };

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedRows(data.map(item => item.inquiryId));
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (id) => {
        if (selectedRows.includes(id)) {
            setSelectedRows(selectedRows.filter(row => row !== id));
        } else {
            setSelectedRows([...selectedRows, id]);
        }
    };

    return (
        <Box p={2}>
            <Paper sx={{ p: 2, display: 'flex', gap: 2, mb: 2 }}>
                <Tooltip title="Filter">
                    <IconButton onClick={() => setFilterVisible(!filterVisible)}>
                        <FilterList />
                    </IconButton>
                </Tooltip>
                <Link to="/main/v3/quatationMaster">
                    <Button variant="contained" startIcon={<Add />}>
                        Add
                    </Button>
                </Link>
            </Paper>

            {filterVisible && (
                <Paper sx={{ p: 3, mb: 2, bgcolor: '#f5faff' }}>
                    <Grid container spacing={2}>
                        {[
                            { label: 'Company Name', key: 'companyName' },
                            { label: 'Contact Person', key: 'contactPerson' },
                            { label: 'Inquiry No.', key: 'inquiryNumber' },
                            { label: 'Inquiry Date', key: 'inquiryDate', type: 'date' },
                            { label: 'State', key: 'state' },
                            { label: 'City', key: 'city' }
                        ].map(({ label, key, type }) => (
                            <Grid item xs={12} sm={6} md={4} key={key}>
                                <TextField fullWidth label={label} variant="outlined" type={type || 'text'} value={filters[key]} onChange={(e) => setFilters({ ...filters, [key]: e.target.value })} />
                            </Grid>
                        ))}
                    </Grid>
                    <Box mt={3} display="flex" justifyContent="center" gap={2}>
                        <Button variant="contained" onClick={handleSearch}>
                            Search
                        </Button>
                        <Button variant="outlined" onClick={handleReset}>
                            Reset
                        </Button>
                    </Box>
                </Paper>
            )}

            <Paper sx={{ p: 2, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box display="flex" gap={2} alignItems="center">
                    <Checkbox checked={selectAll} onChange={handleSelectAll} />
                    <Tooltip title="Delete Selected">
                        <IconButton color="error" onClick={handleDelete}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Typography variant="body2">
                    Showing: {data.length}/{totalCount}
                </Typography>
                <Button variant="outlined" startIcon={<Download />} onClick={handleExport}>
                    Export
                </Button>
            </Paper>

            <Box display="flex" flexDirection="column" gap={2}>
                {data.map((item, idx) => (
                    <Paper key={item.inquiryId} sx={{ p: 2, bgcolor: idx % 2 === 0 ? '#f9f9f9' : themeColors.neutral.surface }}>
                        <Box display="flex" alignItems="center" gap={2}>
                            <Checkbox
                                checked={selectedRows.includes(item.inquiryId)}
                                onChange={() => handleRowSelect(item.inquiryId)}
                            />
                            <Avatar sx={{ bgcolor: '#90caf9' }}>{item.companyName?.[0]?.toUpperCase()}</Avatar>
                            <Typography
                                variant="h6"
                                sx={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/main/v3/editInquiryMaster/${item.inquiryId}`)}
                            >
                                {item.clientname}
                            </Typography>
                        </Box>

                        <Divider sx={{ my: 1 }} />

                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="body2" color="text.secondary">
                                    {item.city}{item.state && `, ${item.state}`}
                                </Typography>
                                <Typography variant="body2">{item.inquiryNumber}</Typography>
                                <Typography variant="body2">
                                    {item.contactPerson} ({item.mobileNo})
                                </Typography>
                            </Grid>
                            <Grid item xs={6} textAlign="right">
                                {/* <Typography variant="body2">Status: {item.LeadStatus}</Typography> */}
                                <Typography variant="body2">
                                    {new Date(item.inquiryDate).toLocaleDateString('en-GB')}
                                </Typography>
                                {/* <Typography variant="body2">Source: {item.LeadSource}</Typography> */}
                            </Grid>
                        </Grid>
                    </Paper>
                ))}
                {data.length === 0 && (
                    <Typography align="center" color="text.secondary" mt={4}>
                        No inquiry records found.
                    </Typography>
                )}
            </Box>

            {data.length < totalCount && (
                <Box mt={2} textAlign="center">
                    <Button
                        variant="contained"
                        onClick={() => setOffset((prev) => prev + limit)}
                        endIcon={<ExpandMore />}
                    >
                        Show More
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default InquiryDetail;